import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
import { ApiCall } from '../helper/axios';
const ProjectOptionsContext = createContext(null);
export const ProjectOptionsProvider = ({ children }) => {
    const [sampleStatusOptions, setSampleStatusOptions] = useState([]);
    const [categoryOptions, setCategoryOptions] = useState([]);
    const [affiliateNetworkOptions, setAffiliateNetworkOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const fetchOptions = async () => {
        setLoading(true);
        try {
            const res = await ApiCall('GET', '/api/utility/options-all', null, {});
            if (res?.data?.success) {
                const { categories, sampleStatus, affiliateNetworks } = res.data.data;
                setCategoryOptions(categories || []);
                setSampleStatusOptions(sampleStatus || []);
                setAffiliateNetworkOptions(affiliateNetworks || []);
            }
        }
        catch (error) {
            console.error('Failed to fetch project options', error);
        }
        finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchOptions();
    }, []);
    const value = {
        sampleStatusOptions,
        categoryOptions,
        affiliateNetworkOptions,
        loading,
        refreshOptions: fetchOptions,
    };
    return (_jsx(ProjectOptionsContext.Provider, { value: value, children: children }));
};
export const useProjectOptions = () => {
    const context = useContext(ProjectOptionsContext);
    if (!context) {
        throw new Error('useProjectOptions must be used within a ProjectOptionsProvider');
    }
    return context;
};
